import { HttpClient } from "@angular/common/http";
import { GoogleGeocoding } from "app/shared/models/google.results.models";
import { goog } from "../api/apihandler";

export class GoogleMapFunctions {
    k = `&${ goog }`;
    constructor(private http:HttpClient){}

    geoCodeSearch(search, region){
        return this.http.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + search + '&region='+ region + this.k )
    }
    
    extractLatLongFromGeocoding(geo: GoogleGeocoding){
        return {
            lat: geo.results[0].geometry.location.lat,
            long: geo.results[0].geometry.location.lng
        }
    }
    
}